<div class="container-fluid">
    <menu-icon-bar [endorsement]="endorsement"></menu-icon-bar>
    <title-bar [endorsement]="endorsement"></title-bar>
    <router-outlet></router-outlet>
</div>